import {Tag} from "@blueprintjs/core";
import styled from "@emotion/styled";
import React, {useCallback} from "react";
import {OptionType} from "../../../../common/types/option";

export interface PresentTagCommonProps {
  option: OptionType;
  onChange: (option: OptionType) => void;
  isDragging: boolean;
}
const PrimaryColor = "#14305A";
const SecondaryColor = "#797979";
export const PresentTagCommon: React.FC<PresentTagCommonProps> = ({option, onChange, isDragging}) => {
  //UseCallback Section
  const onClick = useCallback(() => {
    onChange(option);
  }, [onChange, option]);
  return (
    <StyledTag
      isDragging={isDragging}
      endIcon={
        <StyledTagIconClose onClick={onClick}>
          <TagIconCommon />
        </StyledTagIconClose>
      }
      icon={<DragIconCommon />}
    >
      {option.key}
    </StyledTag>
  );
};
const StyledTag = styled(Tag)<{isDragging: boolean}>`
  font-family: "Roboto", serif;
  &.bp5-tag {
    background-color: ${(props) => (props.isDragging ? `${SecondaryColor}` : `${PrimaryColor}`)};
    padding: 6px;
    gap: 8px;
    box-shadow: 0 2px 2px 0 #0000001a;
    border-radius: 4px;
  }
  &.bp5-fill {
    font-size: 12px;
    font-weight: 400;
  }
`;
const StyledTagIconClose = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
  &:hover {
    opacity: 0.7;
  }
`;
const TagIconCommon = () => {
  return (
    <svg
      style={{cursor: "pointer"}}
      width="7"
      height="8"
      viewBox="0 0 7 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.79406 1.7574C7.0675 1.49156 7.0675 1.05983 6.79406 0.793986C6.52063 0.528144 6.07656 0.528144 5.80312 0.793986L3.49969 3.03557L1.19406 0.796113C0.920625 0.530271 0.476562 0.530271 0.203125 0.796113C-0.0703125 1.06195 -0.0703125 1.49368 0.203125 1.75952L2.50875 3.99898L0.205312 6.24056C-0.068125 6.5064 -0.068125 6.93813 0.205312 7.20397C0.47875 7.46981 0.922813 7.46981 1.19625 7.20397L3.49969 4.96239L5.80531 7.20184C6.07875 7.46768 6.52281 7.46768 6.79625 7.20184C7.06969 6.936 7.06969 6.50427 6.79625 6.23843L4.49062 3.99898L6.79406 1.7574Z"
        fill="#FA545E"
      />
    </svg>
  );
};

const DragIconCommon = () => {
  return (
    <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.3125 3.03846C1.6606 3.03846 1.99444 2.90474 2.24058 2.66671C2.48672 2.42869 2.625 2.10585 2.625 1.76923C2.625 1.43261 2.48672 1.10978 2.24058 0.871749C1.99444 0.633722 1.6606 0.5 1.3125 0.5C0.964403 0.5 0.630564 0.633722 0.384422 0.871749C0.138281 1.10978 0 1.43261 0 1.76923C0 2.10585 0.138281 2.42869 0.384422 2.66671C0.630564 2.90474 0.964403 3.03846 1.3125 3.03846ZM1.3125 7.26923C1.6606 7.26923 1.99444 7.13551 2.24058 6.89748C2.48672 6.65945 2.625 6.33662 2.625 6C2.625 5.66338 2.48672 5.34055 2.24058 5.10252C1.99444 4.86449 1.6606 4.73077 1.3125 4.73077C0.964403 4.73077 0.630564 4.86449 0.384422 5.10252C0.138281 5.34055 0 5.66338 0 6C0 6.33662 0.138281 6.65945 0.384422 6.89748C0.630564 7.13551 0.964403 7.26923 1.3125 7.26923ZM2.625 10.2308C2.625 9.89415 2.48672 9.57131 2.24058 9.33329C1.99444 9.09526 1.6606 8.96154 1.3125 8.96154C0.964403 8.96154 0.630564 9.09526 0.384422 9.33329C0.138281 9.57131 0 9.89415 0 10.2308C0 10.5674 0.138281 10.8902 0.384422 11.1283C0.630564 11.3663 0.964403 11.5 1.3125 11.5C1.6606 11.5 1.99444 11.3663 2.24058 11.1283C2.48672 10.8902 2.625 10.5674 2.625 10.2308ZM5.6875 3.03846C6.0356 3.03846 6.36944 2.90474 6.61558 2.66671C6.86172 2.42869 7 2.10585 7 1.76923C7 1.43261 6.86172 1.10978 6.61558 0.871749C6.36944 0.633722 6.0356 0.5 5.6875 0.5C5.3394 0.5 5.00556 0.633722 4.75942 0.871749C4.51328 1.10978 4.375 1.43261 4.375 1.76923C4.375 2.10585 4.51328 2.42869 4.75942 2.66671C5.00556 2.90474 5.3394 3.03846 5.6875 3.03846ZM7 6C7 5.66338 6.86172 5.34055 6.61558 5.10252C6.36944 4.86449 6.0356 4.73077 5.6875 4.73077C5.3394 4.73077 5.00556 4.86449 4.75942 5.10252C4.51328 5.34055 4.375 5.66338 4.375 6C4.375 6.33662 4.51328 6.65945 4.75942 6.89748C5.00556 7.13551 5.3394 7.26923 5.6875 7.26923C6.0356 7.26923 6.36944 7.13551 6.61558 6.89748C6.86172 6.65945 7 6.33662 7 6ZM5.6875 11.5C6.0356 11.5 6.36944 11.3663 6.61558 11.1283C6.86172 10.8902 7 10.5674 7 10.2308C7 9.89415 6.86172 9.57131 6.61558 9.33329C6.36944 9.09526 6.0356 8.96154 5.6875 8.96154C5.3394 8.96154 5.00556 9.09526 4.75942 9.33329C4.51328 9.57131 4.375 9.89415 4.375 10.2308C4.375 10.5674 4.51328 10.8902 4.75942 11.1283C5.00556 11.3663 5.3394 11.5 5.6875 11.5Z"
        fill="white"
      />
    </svg>
  );
};
